import axios from "axios";
import { createPaginatedStateWithSummary, handlePaginatedResponse, createPaginatedState } from '../helpers/paginationState';

export const  state = {
    cart:[],
    oldcart:[],
    products:"",
    total_cart:"",
    held_sales: [],
    hold_details: [],
    all_held_sales: createPaginatedState(),
    save_status:false,
    saleId:'',
    // sale_receipt:'',
    sale_analysis:[],
    sale_return:createPaginatedStateWithSummary(50, {
        totalAmount: 0,
    }),
    sale_payments:createPaginatedStateWithSummary(50, {
        totalAmount: 0,
    }),
    filter_status:false,
    pending_orders:[],
    ready_orders:[],
    monthlysale_analysis:createPaginatedState(),
    monthlyprofit_analysis: createPaginatedStateWithSummary(50, {
        totalAmount: 0,
    }),
    sales_details:[],
    sale_creditpayments:[],
    sale_returndetails:[],    
    sale_save_status:false,
    payments_data: createPaginatedStateWithSummary(50, {
        totalAmount: 0,
    }),
    sale_creditpayments_data: {
        data: [],
        meta: {
            current_page: 1,
            from: 1,
            last_page: 1,
            per_page: 10,
            to: 0,
            total: 0,
        },
        isServerPaginated: false,
        summary: {
            totalAmount: 0,
        }
    },
};
export const getters = {
    Products: state => state.products.data,
    TotalCart: state => state.total_cart,
    Cart: state => state.cart.data,
    SaleHeld: state => state.held_sales.data,
    HoldInvoice: state => state.hold_details.data,
    AllSaleHeld: state => state.all_held_sales.data,
    AllSaleHeldPagination: state => state.all_held_sales.meta,
    AllSaleHeldPaginated: state => state.all_held_sales.data,
    AllSaleHeldServerPaginated: state => state.all_held_sales.isServerPaginated,
    SaveSaleStatus: state => state.save_status,
    SaleSaveStatus: state => state.sale_save_status,
    SalesId: state => state.saleId,
    // SalesReceipt: state => state.sale_receipt.data,
    SalesAnalysis: state => state.sale_analysis.data,
    SalesReturn: state => state.sale_return.data,
    SalesReturnPagination: state => state.sale_return.meta,
    SalesReturnPaginated: state => state.sale_return.data,
    IsSalesReturnServerPaginated: state => state.sale_return.isServerPaginated,
    SalesReturnSummary: state => state.sale_return.summary,
    SalePayments: state => state.sale_payments.data,
    SalePaymentsPagination: state => state.sale_payments.meta,
    SalePaymentsPaginated: state => state.sale_payments.data,
    IsSalePaymentsServerPaginated: state => state.sale_payments.isServerPaginated,
    PendingOrders: state => state.pending_orders.data,
    ReadyOrders: state => state.ready_orders.data,
    filterStatus: state => state.filter_status,
    MonthlySalesAnalysis: state => state.monthlysale_analysis.data,
    MonthlySalesAnalysisPagination: state => state.monthlysale_analysis.meta,
    MonthlySalesAnalysisPaginated: state => state.monthlysale_analysis.data,
    IsMonthlySalesAnalysisServerPaginated: state => state.monthlysale_analysis.isServerPaginated,
    MonthlySalesAnalysisSummary: state => state.monthlysale_analysis.summary,

    MonthlyProfitsAnalysis: state => state.monthlyprofit_analysis.data,
    MonthlyProfitsAnalysisPagination: state => state.monthlyprofit_analysis.meta,
    MonthlyProfitsAnalysisPaginated: state => state.monthlyprofit_analysis,
    IsMonthlyProfitsAnalysisServerPaginated: state => state.monthlyprofit_analysis.isServerPaginated,
    MonthlyProfitsAnalysisSummary: state => state.monthlyprofit_analysis.summary,
    SaleDetails: state => state.sales_details.data,
    SaleCreditPayments: state => state.sale_creditpayments.data,
    SaleReturnDetails: state => state.sale_returndetails.data,
    PaymentsData: state => state.payments_data.data,
    PaymentsDataPagination: state => state.payments_data.meta,
    PaymentsDataPaginated: state => state.payments_data.data,
    PaymentsDataSummary: state => state.payments_data.summary,
    IsPaymentsDataServerPaginated: state => state.payments_data.isServerPaginated,
    SaleCreditPaymentsData: state => state.sale_creditpayments_data.data,
    SaleCreditPaymentsPagination: state => state.sale_creditpayments_data.meta,
    IsSaleCreditPaymentsServerPaginated: state => state.sale_creditpayments_data.isServerPaginated,
    SaleCreditPaymentsSummary: state => state.sale_creditpayments_data.summary,

};
 export const mutations= {
    SET_SAVE_STATUS(state, newValue) {
        state.save_status = newValue
    },
    SET_SALESAVE_STATUS(state, newValue) {
        state.sale_save_status = newValue
    },
    SET_CART(state, newValue) {
        state.cart = newValue
    },
    SET_HOLD(state, newValue) {
        state.held_sales = newValue
    },
    SET_HOLD_DETAILS(state, newValue) {
        state.hold_details = newValue
    },
    SET_ALL_HOLD(state, response) {
        handlePaginatedResponse(state.all_held_sales, response);
    },
    SET_ITEMS(state, newValue) {
        state.products = newValue
    },
    SET_TOTAL_CART(state, newValue) {
        state.total_cart = newValue
    },
    SET_SALE_ID(state, newValue) { 
        state.saleId = newValue
    },
    // SET_SALE_RECEIPT(state, newValue) { 
    //     state.sale_receipt = newValue
    // },
    SET_SALE_ANALYSIS(state, newValue){
        state.sale_analysis = newValue
    },
    SET_SALE_RETURNS(state, response){
        handlePaginatedResponse(state.sale_return, response);
    },

    SET_SALE_PAYMENTS(state, response){
        handlePaginatedResponse(state.sale_payments, response);
    },
    SET_FILTER_STATUS(state, newValue) {
        state.filter_status = newValue
    },
    SET_PENDING_ORDERS(state, newValue) {
        state.pending_orders = newValue
    },
    SET_READY_ORDERS(state, newValue) {
        state.ready_orders = newValue
    },
    SET_MONTHLYSALE_ANALYSIS(state, response){
        handlePaginatedResponse(state.monthlysale_analysis, response);
    },
    SET_MONTHLYPROFIT_ANALYSIS(state, response){
        handlePaginatedResponse(state.monthlyprofit_analysis, response);
    },
    SET_SALEDETAILS(state, newValue){
        state.sales_details = newValue
    },
    SET_SALE_CREDITPAYMENTS(state, newValue){
        state.sale_creditpayments = newValue
    },
    SET_SALE_RETURNDETAILS(state, newValue){
        state.sale_returndetails = newValue
    },
    SET_OLD_CART(state) {
        state.oldcart = state.cart
    },
    FetchProductUpdates(state){
        state.oldcart.data.filter((item)=>{
            if(item.type == 1){
                // Find the index of the product in the Products array
                const index = state.products.data.findIndex((pdt) => pdt.id === item.product_id);
                // If the product exists, update its instock and replace the Products array
                if (index !== -1) {
                    // Create a copy of the Products array to avoid mutating the original directly
                    const updatedProducts = [...state.products.data];
                    
                    // Update the instock value
                    updatedProducts[index].instock -= (item.quantity * item.baseQty);
                    
                    // Replace the Products array with the updated array
                    state.products.data = updatedProducts;
                }
            }            
        });
    },
        SET_PAYMENTS_DATA(state, response) {
            handlePaginatedResponse(state.payments_data, response);
    },
    RESET_PAYMENTS_PAGINATION(state) {
        state.payments_data.data = [];
        state.payments_data.meta = {current_page: 1, from: 1, last_page: 1, per_page: 50, to: 0, total: 0};
        state.payments_data.summary = {totalAmount: 0};
        state.payments_data.isServerPaginated = false;
    },
    SET_SALE_CREDITPAYMENTS_DATA(state, response) {
        if (response && response.data) {
            state.sale_creditpayments_data.data = response.data;

            if (response.summary) {
                state.sale_creditpayments_data.summary = response.summary;
            } else {
                state.sale_creditpayments_data.summary = { totalAmount: 0 };
            }

            if (response.meta && response.links) {
                state.sale_creditpayments_data.meta = response.meta;
                state.sale_creditpayments_data.isServerPaginated = true;
            } else {
                state.sale_creditpayments_data.meta = {
                    current_page: 1,
                    from: 1,
                    last_page: 1,
                    per_page: response.data.length || 50,
                    to: response.data.length || 0,
                    total: response.data.length || 0,
                };
                state.sale_creditpayments_data.isServerPaginated = false;
            }
        } else {
            state.sale_creditpayments_data.data = [];
            state.sale_creditpayments_data.meta = { current_page: 1, from: 1, last_page: 1, per_page: 10, to: 0, total: 0 };
            state.sale_creditpayments_data.summary = { totalAmount: 0 };
            state.sale_creditpayments_data.isServerPaginated = false;
        }
    },
    RESET_SALE_CREDITPAYMENTS_PAGINATION(state) {
        state.sale_creditpayments_data.data = [];
        state.sale_creditpayments_data.meta = { current_page: 1, from: 1, last_page: 1, per_page: 10, to: 0, total: 0 };
        state.sale_creditpayments_data.summary = { totalAmount: 0 };
        state.sale_creditpayments_data.isServerPaginated = false;
    },    

 };
  export const actions={

    // add products to shop cart
    addToCart({ dispatch, commit }, data) {
        commit('SET_SALESAVE_STATUS', true)
        axios.post('sales_cart', data).then(() => {
            commit('SET_SALESAVE_STATUS', false)
            dispatch('fetchCart')
            dispatch('fetchTotCart')
        }).catch(()=>{
            commit('SET_SALESAVE_STATUS', false)
            let message = { 'msg': "Failed to add Item" }
            dispatch('notification/error', message, { root: true })
        })
    },

    // add products to shop cart
    addToCart1({ dispatch, commit }, data) {
        commit('SET_SALESAVE_STATUS', true)
        axios.post('add_held_sale', data).then(() => {
            commit('SET_SALESAVE_STATUS', false)
            let message = { 'msg': "Item added successfully" }
            dispatch('notification/success', message, { root: true })
            dispatch('fetchHeld')
            dispatch('fetchAllHeld')
        }).catch(()=>{
            commit('SET_SALESAVE_STATUS', false)
            let message = { 'msg': "Failed to add Item" }
            dispatch('notification/error', message, { root: true })
        })
    },

    editCart({ dispatch, commit }, data) {
        commit('SET_SALESAVE_STATUS', true)
        axios.put(`sales_cart/${data.id}`, data).then(response => {
            commit('SET_SALESAVE_STATUS', false)
            dispatch('fetchCart')
            dispatch('fetchTotCart')
            if(response.status==201) {
                let message = { 'msg': "Failed to edit Item" }
                dispatch('notification/error', message, { root: true })
            }
        }).catch(()=>{
            commit('SET_SALESAVE_STATUS', false)
            let message = { 'msg': "Failed to edit Item" }
            dispatch('notification/error', message, { root: true })
        })
    },

    deleteCart({ dispatch, commit }, data) {
        commit('SET_SALESAVE_STATUS', true)
        axios.delete(`sales_cart/${data.id}`).then(response => {
            commit('SET_SALESAVE_STATUS', false)
            dispatch('fetchCart')
            dispatch('fetchTotCart')
            if(response.status==201) {
                let message = { 'msg': "Failed to delete Item from cart" }
                dispatch('notification/error', message, { root: true })
            }
        }).catch(()=>{
            commit('SET_SALESAVE_STATUS', false)
            let message = { 'msg': data.name+' adding failed' }
            dispatch('notification/error', message, { root: true })
        })
    },

    // Process Sale
    saveSalePrint({ dispatch, commit }, data) {
        commit('SET_SALESAVE_STATUS', true)
        commit('SET_OLD_CART')
        axios.post(`sales`, data).then(response => {
            commit('SET_SALESAVE_STATUS', false)
            dispatch('fetchCart')
            dispatch('fetchTotCart')
            if (response.status==200){
                commit('FetchProductUpdates')
                commit('SET_SALE_ID', response.data.id)
            }else if(response.status==202){
                commit('SET_SALE_ID', response.data.id)
                let message = { 'msg': response.data.message+'!!  Kindly correct this and syncronize the sale' }
                dispatch('notification/error', message, { root: true })
            }else{
                let message = { 'msg': "Failed to record Sale" }
                dispatch('notification/error', message, { root: true })
            }
        }).catch(()=>{
            commit('SET_SALESAVE_STATUS', false)
            let message = { 'msg': "Failed to record Sale" }
            dispatch('notification/error', message, { root: true })
        })
    },

    // Process Sale
    saveSaleExit({ dispatch, commit }, data) {
        commit('SET_SALESAVE_STATUS', true)
        commit('SET_OLD_CART')
        axios.post(`sales`, data).then(response => {
            commit('SET_SALESAVE_STATUS', false)
            dispatch('fetchCart')
            dispatch('fetchTotCart')
            if (response.status==200){
                commit('FetchProductUpdates')
                let message = { 'msg': "Sale Recorded successfully" }
                dispatch('notification/success', message, { root: true })
            }else if(response.status==202){
                let message = { 'msg': response.data.message+'!!  Kindly correct this and syncronize the sale' }
                dispatch('notification/error', message, { root: true })
            }else{
                let message = { 'msg': "Failed to record Sale" }
                dispatch('notification/error', message, { root: true })
            }
        }).catch(()=>{
            commit('SET_SALESAVE_STATUS', false)
            let message = { 'msg': "Failed to record Sale" }
            dispatch('notification/error', message, { root: true })
        })
    },


    holdSale({ dispatch, commit }, data) {
        commit('SET_SALESAVE_STATUS', true)
        axios.post('sale_hold', data).then((response) => {
            commit('SET_SALESAVE_STATUS', false)
            if (response.status==201){
                let message = { 'msg': "No Items in Cart To Hold" }
                dispatch('notification/error', message, { root: true })

            }else{
                dispatch('fetchCart')
                dispatch('fetchTotCart')
                dispatch('fetchHeld')
                let message = { 'msg': "Order Held successfully" }
                dispatch('notification/success', message, { root: true })

            }

        }).catch(()=>{
            commit('SET_SALESAVE_STATUS', false)
            let message = { 'msg': "Failed to Hold a Sale" }
            dispatch('notification/error', message, { root: true })
        })
    },
    unHoldSale({ dispatch, commit }, data) {
        commit('SET_SALESAVE_STATUS', true)
        axios.put(`sale_hold/${data.id}`, data).then(response => {
            commit('SET_SALESAVE_STATUS', false)
            dispatch('fetchCart')
            dispatch('fetchTotCart')
            dispatch('fetchHeld')
            dispatch('fetchAllHeld')
            if (response.status==200){
                let message = { 'msg': "Order UnHeld successfully" }
                dispatch('notification/success', message, { root: true })
            }else if(response.status==201) {
                let message = { 'msg': "First Process the Order in Cart" }
                dispatch('notification/error', message, { root: true })
            }
        }).catch(()=>{
            commit('SET_SALESAVE_STATUS', false)
            let message = { 'msg': "Failed to UnHold" }
            dispatch('notification/error', message, { root: true })
        })
    },
    deleteHold({ dispatch, commit }, data) {
        commit('SET_SALESAVE_STATUS', true)
        axios.delete(`sale_hold/${data.id}`).then(() => {
            commit('SET_SALESAVE_STATUS', false)
            dispatch('fetchCart')
            dispatch('fetchTotCart')
            dispatch('fetchHeld')
            let message = { 'msg': "Order Deleted Success" }
            dispatch('notification/success', message, { root: true })
        }).catch(()=>{
            commit('SET_SALESAVE_STATUS', false)
            let message = { 'msg': 'Failed to delete Order' }
            dispatch('notification/error', message, { root: true })
        })
    },

    fetchCart({ commit }) {
        axios.get('sales_cart').then(cart => {
            commit('SET_CART', cart.data)
        })
    },

    fetchItems({ commit }) {
        axios.get('get_items').then(cart => {
            commit('SET_ITEMS', cart.data)
        })
    },

    fetchTotCart({ commit }) {
        axios.get('total_cart').then(total => {
            commit('SET_TOTAL_CART', total.data)
        })
    },
    fetchHeld({ commit }) {
        axios.get('sale_hold').then(total => {
            commit('SET_HOLD', total.data)
        })
    },
    fetchHoldInvoice({ commit },id) {
        axios.get(`sale_hold/${id}`).then(total => {
            commit('SET_HOLD_DETAILS', total.data)
        })
    },
    
    fetchAllHeld({ commit, dispatch }, payload = {}) {
        commit('SET_FILTER_STATUS', true);

        let apiPayload = { ...payload };

        apiPayload.page = apiPayload.page ?? 1;
        apiPayload.per_page = apiPayload.per_page ?? 50;

        axios.get('all_held_sales', { params: apiPayload }).then(response => {
            commit('SET_ALL_HOLD', response.data);
            commit('SET_FILTER_STATUS', false);
        }).catch(() => {
            commit('SET_ALL_HOLD', { data: [], meta:{} });
            commit('SET_FILTER_STATUS', false);
            let errorMsg = 'Failed to load held sales report.';
            dispatch('notification/error', { msg: errorMsg }, { root: true });
        });
    },

    fetchSales({ commit }, payload) {
        axios.post('salesanalysis_report', payload).then(total => {
            commit('SET_SALE_ANALYSIS', total.data)
        })
    },

    returnSale({ dispatch, commit }, payload) {
        commit('SET_SAVE_STATUS', true)
        axios.post(`return_sales`, payload).then(response => {
            commit('SET_SAVE_STATUS', false)
            dispatch('fetchSales', payload.filterSales)
            if (response.data.status==200){
                let message = { 'msg': "Sale Return Recorded successfully" }
                dispatch('notification/success', message, { root: true })
            }else if(response.status==202) {
                let message = { 'msg': "Failed to record Sale Return" }
                dispatch('notification/error', message, { root: true })
            }
        }).catch(()=>{
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': "Failed to record Sale Return" }
            dispatch('notification/error', message, { root: true })
        })
    },
    fetchReturns({ commit, dispatch }, payload) {
         commit('SET_FILTER_STATUS', true);
        let apiPayload = {...payload};
        apiPayload.page = payload.page ?? 1;
        apiPayload.per_page = payload.per_page ?? 50;
     
        axios.get('fetch_salereturns', apiPayload).then(response => {
            commit('SET_SALE_RETURNS', response.data);
            commit('SET_FILTER_STATUS', false);
        }).catch(() => {
            commit('SET_SALE_RETURNS', {data: [], meta: {}, summary: {totalAmount: 0}});
            commit('SET_FILTER_STATUS', false);
            let errorMsg = 'Failed to load payments report.';
            dispatch('notification/error', {msg: errorMsg}, {root: true});
        });
    },

    fetchPayments({ commit, dispatch }, payload) {
        commit('SET_FILTER_STATUS', true);
        let apiPayload = {...payload};
        apiPayload.page = payload.page ?? 1;
        apiPayload.per_page = payload.per_page ?? 50;
     
        axios.post('payments', apiPayload).then(response => {
            commit('SET_SALE_PAYMENTS', response.data);
            commit('SET_FILTER_STATUS', false);
        }).catch(() => {
            commit('SET_SALE_PAYMENTS', {data: [], meta: {}, summary: {totalAmount: 0}});
            commit('SET_FILTER_STATUS', false);
            let errorMsg = 'Failed to load payments report.';
            dispatch('notification/error', {msg: errorMsg}, {root: true});
        });
    },

    fetchPendingOrders({ commit }) {
        axios.get('sales_status').then(order => {
            commit('SET_PENDING_ORDERS', order.data)
        })
    },


    // Confirm Orders
    Confirm_orders({ dispatch, commit }, data) {
        commit('SET_SAVE_STATUS', true)
        axios.post('confirmorder', data).then(() => {
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': "Order successfully confirmed ready" }
            dispatch('notification/success', message, { root: true })
            dispatch('fetchPendingOrders')
        }).catch(()=>{
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': "Failed to cofirm order" }
            dispatch('notification/error', message, { root: true })
        })
    },

    fetchReadyOrders({ commit }) {
        axios.get('readyorders').then(order => {
            commit('SET_READY_ORDERS', order.data)
        })
    },


    // Confirm Served Orders
    Confirm_servedorders({ dispatch, commit }, data) {
        commit('SET_SAVE_STATUS', true)
        axios.post('confirmserved', data).then(() => {
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': "Order successfully confirmed served" }
            dispatch('notification/success', message, { root: true })
            dispatch('fetchReadyOrders')
        }).catch(()=>{
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': "Failed to cofirm order" }
            dispatch('notification/error', message, { root: true })
        })
    },

    // Fetch for monthly sales analysis report
    fetchMonthlySales({ commit, dispatch }, payload) {
        commit('SET_FILTER_STATUS', true);
        let apiPayload = {...payload};
        apiPayload.page = payload.page ?? 1;
        apiPayload.per_page = payload.per_page ?? 50;
     
        axios.post('monthlysales_analysis', apiPayload).then(response => {
            commit('SET_MONTHLYSALE_ANALYSIS', response.data);
            commit('SET_FILTER_STATUS', false);
        }).catch(() => {
            commit('SET_MONTHLYSALE_ANALYSIS', {data: [], meta: {}, summary: {totalAmount: 0}});
            commit('SET_FILTER_STATUS', false);
            let errorMsg = 'Failed to load monthly sales report.';
            dispatch('notification/error', {msg: errorMsg}, {root: true});
        });
    },
    

    // Fetch for monthly profits analysis report
    fetchMonthlyProfits({ commit, dispatch }, payload) {
           commit('SET_FILTER_STATUS', true);
        let apiPayload = {...payload};
        apiPayload.page = payload.page ?? 1;
        apiPayload.per_page = payload.per_page ?? 50;
     
        axios.post('monthlyprofits_analysis', apiPayload).then(response => {
            commit('SET_MONTHLYPROFIT_ANALYSIS', response.data);
            commit('SET_FILTER_STATUS', false);
        }).catch(() => {
            commit('SET_MONTHLYPROFIT_ANALYSIS', {data: [], meta: {}, summary: {totalAmount: 0}});
            commit('SET_FILTER_STATUS', false);
            let errorMsg = 'Failed to load monhly analysis report.';
            dispatch('notification/error', {msg: errorMsg}, {root: true});
        });
    },

    fetchSalesDetails({ commit }, payload) {
        axios.post('fetchsales_details', payload).then(res => {
            commit('SET_SALEDETAILS', res.data)
        })
    },

    pickSale({ dispatch, commit }, data) {
        commit('SET_SAVE_STATUS', true)
        axios.post(`pick_sales`, data).then(response => {
            commit('SET_SAVE_STATUS', false)
            dispatch('fetchSales')
            if (response.data.status==200){
                let message = { 'msg': "Item picked successfully" }
                dispatch('notification/success', message, { root: true })
            }else if(response.status==202) {
                let message = { 'msg': "Failed to record Item picked" }
                dispatch('notification/error', message, { root: true })
            }
        }).catch(()=>{
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': "Failed to record Sale Return" }
            dispatch('notification/error', message, { root: true })
        })
    },

    fetchCreditPayments({ commit }, payload) {
        commit('SET_FILTER_STATUS', true)
        axios.post('credit_payments', payload).then(total => {
            commit('SET_FILTER_STATUS', false)
            commit('SET_SALE_CREDITPAYMENTS', total.data)
        })
    },

    RetryReturn({ dispatch, commit }, data) {
        commit('SET_SAVE_STATUS', true)
        axios.post(`retry_return`, data).then(response => {
            commit('SET_SAVE_STATUS', false)
            dispatch('fetchReturns')
            if (response.data.status==200){
                let message = { 'msg': "Return has been synchronized successfully" }
                dispatch('notification/success', message, { root: true })
            }else{
                let message = { 'msg': "Failed to Resynchronize" }
                dispatch('notification/error', message, { root: true })
            }
        }).catch(()=>{
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': "Failed to Resynchronize" }
            dispatch('notification/error', message, { root: true })
        })
    },

    CancelReturn({ dispatch, commit }, data) {
        commit('SET_SAVE_STATUS', true)
        axios.post(`cancel_return`, data).then(response => {
            commit('SET_SAVE_STATUS', false)
            dispatch('fetchReturns')
            if (response.data.status==200){
                let message = { 'msg': "Return has been cancelled successfully" }
                dispatch('notification/success', message, { root: true })
            }else{
                let message = { 'msg': "Failed to cancel Return" }
                dispatch('notification/error', message, { root: true })
            }
        }).catch(()=>{
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': "Failed to  cancel Return" }
            dispatch('notification/error', message, { root: true })
        })
    },

    fetchSaleReturnDetails({ commit }, id){
        axios.get(`fetch_salereturndetails/${id}`).then(response => {
            commit('SET_SALE_RETURNDETAILS', response.data)
        });
    },

    // Modify Payments
    EditPayment({commit, dispatch}, payload) {
        commit('SET_SAVE_STATUS', true);
        axios.put(`update_payment/${payload.id}`, payload).then((response) => {
            if (response.status == 201) {
                let message = {'msg': response.data.message}
                dispatch('notification/error', message, {root: true})
            } else {
                dispatch('fetchPaymentsData', payload.filterdata);
                let message = {'msg': `Payment updated successfully`}
                dispatch('notification/success', message, {root: true})
            }
            commit('SET_SAVE_STATUS', false);
        }).catch(() => {
            commit('SET_SAVE_STATUS', false)
            let message = {'msg': "Error updating Payment"}
            dispatch('notification/error', message, {root: true})
        })
    },

    DeletePayment({commit, dispatch}, payload) {
        commit('SET_SAVE_STATUS', true);
        axios.put(`delete_payment/${payload.id}`).then(() => {
            dispatch('fetchPaymentsData', payload.filterdata);
            let message = {'msg': `Payment deleted successfully`}
            dispatch('notification/success', message, {root: true})
            commit('SET_SAVE_STATUS', false);
        }).catch(() => {
            commit('SET_SAVE_STATUS', false)
            let message = {'msg': "Error in deleting Payment"}
            dispatch('notification/error', message, {root: true})
        })
    },

    fetchPaymentsData({commit, dispatch}, payload) {
        commit('SET_FILTER_STATUS', true);
        let apiPayload = {...payload};
        apiPayload.page = payload.page ?? 1;
        apiPayload.per_page = payload.per_page ?? 50;
     
        axios.post('payments', apiPayload).then(response => {
            commit('SET_PAYMENTS_DATA', response.data);
            commit('SET_FILTER_STATUS', false);
        }).catch(() => {
            commit('SET_PAYMENTS_DATA', {data: [], meta: {}, summary: {totalAmount: 0}});
            commit('SET_FILTER_STATUS', false);
            let errorMsg = 'Failed to load payments report.';
            dispatch('notification/error', {msg: errorMsg}, {root: true});
        });
    },

    fetchCreditPaymentsData({ commit, dispatch }, payload) {
        commit('SET_FILTER_STATUS', true);
        const requiresServerPagination = payload.datefrom !== payload.dateto;

        let apiPayload = { ...payload };

        if (requiresServerPagination) {
            apiPayload.page = payload.page || 1;
            apiPayload.per_page = payload.per_page || 50;
        } else {
            delete apiPayload.page;
            delete apiPayload.per_page;
        }

        axios.post('credit_payments', apiPayload).then(response => {
            commit('SET_SALE_CREDITPAYMENTS_DATA', response.data);
            commit('SET_FILTER_STATUS', false);
        }).catch(() => {
            commit('SET_SALE_CREDITPAYMENTS_DATA', { data: [], meta:{}, summary: { totalAmount: 0 } });
            commit('SET_FILTER_STATUS', false);
            let errorMsg = 'Failed to load credit payments report.';
            dispatch('notification/error', { msg: errorMsg }, { root: true });
        });
    },

  };